import { col, type Shape } from './base.ts';

export const MOVEMENT_RECORD: Shape = [
  col('scenarioName', 'unitless', 'Scenario name for this movement record.'),
  col('scenarioType', 'unitless', 'Scenario type.'),
  col('description', 'unitless', 'Free-text description of the movement.'),
  col('source', 'unitless', 'Originating system / source of the record.'),
  col('status', 'unitless', 'Movement status.'),
  col('executionStatus', 'unitless', 'Execution status of the movement.'),
  col('validationStatus', 'unitless', 'Validation status of the movement.'),
  col('ticketExternalId', 'unitless', 'External ticket id linked to the movement.'),
  col('createdBy', 'unitless', 'User who created the record.'),
  col('wellName', 'unitless', 'Denormalized well name on the record.'),
  col('wellType', 'unitless', 'Denormalized well type on the record.'),
];

/**
 * Well-movement timing on `WellMovement_Agent` (B2): created / planned /
 * actual execution dates and do-not-disturb window. All SCALAR. Bare source
 * columns — `suffix === canonical`, `prefix:''`.
 */
export const MOVEMENT_TIMING: Shape = [
  col('createdDate', 'unitless', 'Date the record was created.'),
  col('plannedExecutionDate', 'unitless', 'Planned execution date.'),
  col('actualExecutionDate', 'unitless', 'Actual execution date.'),
  col('doNotDisturb', 'unitless', 'Do-not-disturb flag.'),
  col('doNotDisturbEndDate', 'unitless', 'Do-not-disturb window end date.'),
];

/**
 * Well-movement control parameter on `WellMovement_Agent` (B2): the adjusted
 * control parameter and its pre/post-optimized values. All SCALAR. Bare source
 * columns — `suffix === canonical`, `prefix:''`.
 */
export const MOVEMENT_CONTROL_PARAMETER: Shape = [
  col('controlParameter', 'unitless', 'Control parameter being adjusted.'),
  col('controlParameterPreOptimizedValue', 'unitless', 'Control-parameter value before optimization.'),
  col('controlParameterPostOptimizedValue', 'unitless', 'Control-parameter value after optimization.'),
];

/**
 * Well-movement baseline vs estimated rates on `WellMovement_Agent` (B2): the
 * baseline and estimated oil/gas/water rates as SCALARS. Bare source columns —
 * `suffix === canonical`, `prefix:''`. Distinct from `PHASE_RATES` (these are
 * `baseline*`/`estimated*` scalar snapshots on a movement record, not the
 * timeseries phase-rate measures).
 */
export const MOVEMENT_RATES: Shape = [
  col('baselineOilRate', 'liquidRate', 'Baseline oil rate before the movement.'),
  col('baselineGasRate', 'gasRate', 'Baseline gas rate before the movement.'),
  col('baselineWaterRate', 'liquidRate', 'Baseline water rate before the movement.'),
  col('estimatedOilRate', 'liquidRate', 'Estimated oil rate after the movement.'),
  col('estimatedGasRate', 'gasRate', 'Estimated gas rate after the movement.'),
  col('estimatedWaterRate', 'liquidRate', 'Estimated water rate after the movement.'),
];
/**
 * The field-grain direct-relation carried by `AllocationFactors_Field_Agent`
 * (B3): the `field` ref to the Field model entity. NOTE the source names the
 * grain ref `field` (NOT `fieldEntity`), so the daily-rollup {@link FIELD_RELATION}
 * (whose suffix is `fieldEntity`) does NOT match here — mirrors the
 * {@link RESERVOIR_OUTPUTS_RELATION} `reservoir`≠`reservoirEntity` precedent.
 * Kept verbatim (`prefix:''` → no rename).
 */
